"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComMiddleWare = void 0;
var _types = require("../com/types");
var _signalrService = require("./signalrService");
var _types2 = require("../config/types");
var _CommandType = require("../../dovahzul/CommandType");
var _StartGameRequest = require("../../dovahzul/requests/StartGameRequest");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var com;
var ComMiddleWare = exports.ComMiddleWare = /*#__PURE__*/function () {
  function ComMiddleWare() {
    var _this = this;
    _classCallCheck(this, ComMiddleWare);
    _defineProperty(this, "middleware", function (api) {
      return function (next) {
        return function (action) {
          switch (action.type) {
            case _types.DISCONNECT:
              {
                com.disconnect();
                break;
              }
            case _types.CONNECT:
              {
                com = new _signalrService.SignalrService();
                com.connect(api);
                break;
              }
            case _types.CONNECTED:
              {
                var state = api.getState();
                com.send(new _StartGameRequest.StartGameRequest(state.config.token, state.config.iId, state.config.gameId, state.config.context, state.config.channel, state.config.rmmid, state.config.replayRound, state.config.language));
                break;
              }
            case _types.COMMAND_SEND:
              {
                com.send(action.payload);
                break;
              }
            case _types.COMMAND_RECEIVED:
              {
                var t = _this.translate(action.payload);
                if (t) api.dispatch(t);
              }
          }
          return next(action);
        };
      };
    });
  }
  return _createClass(ComMiddleWare, [{
    key: "translate",
    value: function translate(command) {
      switch (command.type) {
        case _CommandType.CommandType.StartGameResponse:
          {
            var startData = command;
            console.log("Game Ready");
            return {
              type: _types2.SERVER_CONFIG,
              payload: {
                currencyTruncation: startData.currencyTruncation,
                practice: startData.practice,
                playerId: startData.playerId,
                connectionId: startData.connectionId,
                externalGameSessionId: startData.externalGameSessionId,
                jurisdiction: startData.jurisdiction,
                brand: startData.brand,
                group: startData.group
              }
            };
          }
      }
    }
  }]);
}();
//# sourceMappingURL=middleware.js.map